import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getSports, Sport } from "../data/api";
import useAuth from "../hooks/useAuth";
import Select from "react-select";
import { Box, useTheme } from "@chakra-ui/react";

type Props = {
  sportSelected?: (sport: Sport | "ALL") => any;
};

const SportSelector = ({ sportSelected }: Props) => {
  const [sports, setSports] = useState<Sport[]>([]);
  const { token } = useAuth();
  const { colors } = useTheme();

  const colourStyles = useMemo(
    () => ({
      control: (styles: any) => ({
        ...styles,
        backgroundColor: "white",
        borderColor: colors.gray["900"],
        textAlign: "left",
        color: "black",
      }),
      option: (styles: any, state: any) => ({
        ...styles,
        backgroundColor: "white",
        textAlign: "left",
        color: "black",
      }),
      input: (styles: any) => ({
        ...styles,
        color: "black",
      }),
      menu: (styles: any) => ({
        ...styles,
        backgroundColor: "white",
      }),
      singleValue: (styles: any) => ({
        ...styles,
        color: "black",
      }),
    }),
    [colors]
  );

  const handleChange = useCallback(
    (e: any) => {
      const sport = sports.find((s) => s.title === e.value);
      sportSelected?.(sport ? sport : "ALL");
    },
    [sports, sportSelected]
  );

  useEffect(() => {
    if (token) getSports(token).then(setSports);
  }, [token]);

  return (
    <Box mb={3}>
      <Select
        defaultValue={{ value: "ALL", label: "All Sports" }}
        options={[
          { value: "ALL", label: "All Sports" },
          ...sports.map((s) => ({ value: s.title, label: s.title })),
        ]}
        onChange={handleChange}
        styles={colourStyles}
      />
    </Box>
  );
};

export default SportSelector;
